import { useQueryClient } from "@tanstack/react-query"
import { useRealtimeChannelEvent } from "@/contexts/RealtimeContext"
import { type CommentableEntity, getDiscussionChannelName } from "../services/comment.api"

interface CommentRealtimeEvent {
  entityType?: "COMMUNITY" | "RITUAL"
  entityId?: string
}

const normalizeEntityType = (entityType: CommentableEntity): "COMMUNITY" | "RITUAL" =>
  entityType === "community" ? "COMMUNITY" : "RITUAL"

export const useCommentRealtime = ({
  entityType,
  entityId,
  enabled = true,
}: {
  entityType: CommentableEntity
  entityId: string
  enabled?: boolean
}): void => {
  const queryClient = useQueryClient()
  const expectedEntityType = normalizeEntityType(entityType)
  const channelName = enabled && entityId ? getDiscussionChannelName(entityType, entityId) : null

  useRealtimeChannelEvent(channelName, "discussion:changed", payload => {
    const event = payload as CommentRealtimeEvent

    if (event.entityId !== entityId || event.entityType !== expectedEntityType) {
      return
    }

    void queryClient.invalidateQueries({
      queryKey: ["comments", entityType, entityId],
    })

    if (entityType === "community") {
      void queryClient.invalidateQueries({
        queryKey: ["community-statistics", entityId],
      })
    }
  })
}
